module.exports = __webpack_public_path__ + "img/ring_r_o_null_0.c6b01511.png";